export default __webpack_public_path__ + "static/media/pokemon_rare.57aaaca3.svg";